module.exports = __webpack_public_path__ + "assets/img/Telegram.3c43561d.svg";